import React from "react";

export default function Results() {
  return <div></div>;
}
